import { Select } from "antd";
import { FilterField } from "./FilterShared";

const { Option } = Select;

const BASE_SELECT = { style: { width: "100%" }, allowClear: true };

const cleanValues = (vals) =>
  (Array.isArray(vals) ? vals : [])
    .map((v) => (v == null ? "" : String(v)))
    .filter((v) => v.trim());

const withSelectedOpts = (opts = [], selectedValues, labelMap = {}) => {
  const safeOpts = Array.isArray(opts) ? opts : [];
  const selected = cleanValues(selectedValues);
  const missing = selected.filter((v) => !safeOpts.some((o) => o.value === v));
  return missing.length ? [...safeOpts, ...missing.map((v) => ({ label: labelMap[v] || v, sub_label: labelMap[v] ? v : '', value: v }))] : safeOpts;
};

const buildIdLabelMap = (ids = [], labels = []) =>
  cleanValues(ids).reduce((acc, id, index) => {
    const label = cleanValues(labels)[index];
    if (label) acc[id] = label;
    return acc;
  }, {});

const getSelectedLabels = (ids = [], source = {}, currentIds = [], currentLabels = []) => {
  const optionMap = (Array.isArray(source?.opts) ? source.opts : []).reduce((acc, opt) => {
    if (opt?.value && opt?.label) acc[opt.value] = opt.label;
    return acc;
  }, {});
  const currentMap = buildIdLabelMap(currentIds, currentLabels);

  return cleanValues(ids).map((id) => optionMap[id] || currentMap[id] || id);
};

const LocationSelect = ({ loc = {}, selectedValues, placeholder, onChange }) => {
  const allOpts = withSelectedOpts(loc.opts || [], selectedValues, loc.labelMap || {});
  return (
    <Select
      {...BASE_SELECT}
      mode="multiple"
      showSearch
      placeholder={placeholder}
      filterOption={false}
      onSearch={loc.onSearch || (() => {})}
      loading={Boolean(loc.loading)}
      value={cleanValues(selectedValues)}
      onChange={onChange || (() => {})}
      notFoundContent={loc.loading ? "Searching…" : "Type to search"}
      optionLabelProp="label"
    >
      {allOpts.map((opt) => (
        <Option key={opt.value} value={opt.value} label={opt.label || opt.value}>
          <div style={{ lineHeight: 1.3 }}>
            <div>{opt.label || opt.value}</div>
            {opt.sub_label && (
              <div style={{ fontSize: 11, color: "#8c8c8c" }}>{opt.sub_label}</div>
            )}
          </div>
        </Option>
      ))}
    </Select>
  );
};

const IdSelect = ({ source = {}, value, labels, placeholder, onChange }) => {
  const selectedIds = cleanValues(value);
  const allOpts = withSelectedOpts(
    Array.isArray(source?.opts) ? source.opts : [],
    selectedIds,
    buildIdLabelMap(selectedIds, labels)
  );

  return (
    <Select
      {...BASE_SELECT}
      mode="multiple"
      showSearch
      placeholder={placeholder}
      filterOption={false}
      onSearch={source.onSearch || (() => {})}
      loading={Boolean(source.loading)}
      value={selectedIds}
      onChange={onChange || (() => {})}
      options={allOpts}
      notFoundContent={source.loading ? "Searching" : "Type to search"}
    />
  );
};

const LocationPanel = ({
  values = {},
  set,
  setMany,
  locMain,
  locCurrWork,
  locPastWork,
  locRemote,
  hideWorkLocationFields = false,
  usePmtLocationFields = false,
  countrySearch,
  regionSearch,
  citySearch,
}) => {
  const safeSet = (key) => set?.(key) || (() => {});
  const handlePmtLocationChange = (idKey, labelKey, source) => (nextIds = []) => {
    const ids = cleanValues(nextIds);

    setMany?.({
      [idKey]: ids,
      [labelKey]: getSelectedLabels(
        ids,
        source,
        values[idKey],
        values[labelKey]
      ),
      location: [],
    });
  };

  return (
    <div className="qp-filter-panel-body">
      {usePmtLocationFields ? (
        <>
          <FilterField label="Country">
            <IdSelect source={countrySearch} value={values.countryId} labels={values.countryName} placeholder="Search country" onChange={handlePmtLocationChange("countryId", "countryName", countrySearch)} />
          </FilterField>

          <FilterField label="State">
            <IdSelect source={regionSearch} value={values.regionId} labels={values.regionName} placeholder="Search state" onChange={handlePmtLocationChange("regionId", "regionName", regionSearch)} />
          </FilterField>

          <FilterField label="City">
            <IdSelect source={citySearch} value={values.cityId} labels={values.cityName} placeholder="Search city" onChange={handlePmtLocationChange("cityId", "cityName", citySearch)} />
          </FilterField>
        </>
      ) : (
        <FilterField label="Location">
          <LocationSelect loc={locMain} selectedValues={values.location} placeholder="e.g. New York, USA" onChange={safeSet("location")} />
        </FilterField>
      )}

      {!usePmtLocationFields && !hideWorkLocationFields && (
        <FilterField label="Current Work Location">
          <LocationSelect loc={locCurrWork} selectedValues={values.currentWorkLocation} placeholder="e.g. San Francisco" onChange={safeSet("currentWorkLocation")} />
        </FilterField>
      )}

      {!usePmtLocationFields && !hideWorkLocationFields && (
        <FilterField label="Past Work Location">
          <LocationSelect loc={locPastWork} selectedValues={values.pastWorkLocation} placeholder="e.g. London" onChange={safeSet("pastWorkLocation")} />
        </FilterField>
      )}


    </div>
  );
};

export default LocationPanel;
